export function encodeBase64(value: string): string {
  return window.btoa(unescape(encodeURIComponent(value)));
}

export function decodeBase64(value: string): string {
  return decodeURIComponent(escape(window.atob(value)));
}
